import { IAppState } from 'spw-redux/reducer';
import { OccupancyAndUtilizationSummaries } from 'spw-redux/modules/ou/types';

export const selectProjectRounds = (state: IAppState) => state.ouReducer.rounds;

export const selectSelectedRoundsMap = (state: IAppState) =>
  state.ouReducer.selectedRoundsMap;

export const selectOccupancyAndUtilizationSummaries = (state: IAppState) =>
  state.ouReducer.occupancyAndUtilizationSummaries ||
  ({} as OccupancyAndUtilizationSummaries);

export const selectReportZipFileName = (state: IAppState) =>
  state.ouReducer.reportZipFileName;
